<button
  [class]="cssClass"
  mat-flat-button
  [color]="color"
  [disabled]="(isBusy$ | async) || disabled"
  (click)="clicked.emit($event)"
  type="{{ type }}"
  [tabindex]="tabindex">
  <ng-container *notBusy>
    <div class="flex flex-row items-center">
      <ng-content></ng-content>
    </div>
  </ng-container>
  <mat-progress-spinner *busy [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
</button>
